import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<ClassGroupJnsAlaskaCupPointsCard @event={{@model}}/>",{ moduleName: "bullitt-time-results/templates/event/jns/alaska-cup-points.hbs" })